/* loaded by smart-asset */
export default require("./assets/barcode-scan.png")